export const coordinateRouter = [
  {
    path: '',
    redirect: 'notice'
  },
  {
    path: 'notice',
    meta: {
      title: '通知公告',
    },
    component: () => import('../views/coordinate/page/notice'),
  },
  {
    path: 'noticeDetail',
    meta: {
      title: '通知公告',
    },
    component: () => import('../views/coordinate/page/noticeDetail'),
  },
  {
    path: 'index2',
    meta: {
      title: '数据总览',
    },
    component: () => import('../views/coordinate/page/index2'),
  },
  {
    path: 'verify2',
    meta: {
      title: '考试列表',
    },
    component: () => import('../views/coordinate/page/verify2'),
  },
  {
    path: 'verify2Detail',
    meta: {
      title: '考生审核列表',
    },
    component: () => import('../views/coordinate/page/verify2Detail'),
  },
  {
    path: 'veridy2Student',
    meta: {
      title: '考生审核详情',
    },
    component: () => import('../views/coordinate/page/veridy2Student'),
  },
  {
    path: 'order2',
    meta: {
      title: '订单核对',
    },
    component: () => import('../views/coordinate/page/order2'),
  },
  {
    path: 'index3',
    meta: {
      title: '数据总览',
    },
    component: () => import('../views/coordinate/page/index3'),
  },
  {
    path: 'job3',
    meta: {
      title: '岗位信息',
    },
    component: () => import('../views/coordinate/page/job3'),
  },
  {
    path: 'job3Detail',
    meta: {
      title: '岗位详情',
    },
    component: () => import('../views/coordinate/page/job3Detail'),
  },


  {
    path: 'student3',
    meta: {
      title: '实习生信息',
    },
    component: () => import('../views/coordinate/page/student3'),
  },
  {
    path: 'practice3',
    meta: {
      title: '实习机构数据',
    },
    component: () => import('../views/coordinate/page/practice3'),
  },
  {
    path: 'volunteer',
    meta: {
      title: '志愿填报管理',
    },
    component: () => import('../views/coordinate/page/volunteer'),
  },
  {
    path: 'trainee',
    meta: {
      title: '实习生数据',
    },
    component: () => import('../views/coordinate/page/trainee'),
  },
  {
    path: 'index4',
    meta: {
      title: '数据统计',
    },
    component: () => import('../views/coordinate/page/index4'),
  },
  {
    path: 'order4',
    meta: {
      title: '订单核对',
    },
    component: () => import('../views/coordinate/page/order4'),
  },
  {
    path: 'examroom4',
    meta: {
      title: '考场考生信息',
    },
    component: () => import('../views/coordinate/page/examroom4'),
  },
  {
    path: 'examroomList',
    meta: {
      title: '考场列表',
    },
    component: () => import('../views/coordinate/page/examroomList'),
  },
  {
    path: 'examstudent',
    meta: {
      title: '报名审核',
    },
    component: () => import('../views/coordinate/page/examstudent'),
  },
  {
    path: 'examstudentDetail',
    meta: {
      title: '学生报名信息',
    },
    component: () => import('../views/coordinate/page/examstudentDetail'),
  },



  {
    path: 'index5',
    meta: {
      title: '数据统计',
    },
    component: () => import('../views/coordinate/page/index5'),
  },
  {
    path: 'verify5',
    meta: {
      title: '考试列表',
    },
    component: () => import('../views/coordinate/page/verify5'),
  },
  {
    path: 'verify5Detail',
    meta: {
      title: '考生审核列表',
    },
    component: () => import('../views/coordinate/page/verify5Detail'),
  },
  {
    path: 'veridy5Student',
    meta: {
      title: '考生审核详情',
    },
    component: () => import('../views/coordinate/page/veridy5Student'),
  },
  {
    path: 'org5List',
    meta: {
      title: '基地列表',
    },
    component: () => import('../views/coordinate/page/org5List'),
  },
  {
    path: 'organ5',
    meta: {
      title: '机构数据',
    },
    component: () => import('../views/coordinate/page/organ5'),
  },
  {
    path: 'room',
    meta: {
      title: '班级数据',
    },
    component: () => import('../views/coordinate/page/room'),
  },
  {
    path: 'student',
    meta: {
      title: '学生数据',
    },
    component: () => import('../views/coordinate/page/student'),
  },
  {
    path: 'info',
    meta: {
      title: '机构信息',
    },
    component: () => import('../views/coordinate/page/info'),
  },
  {
    path: 'account',
    meta: {
      title: '帐号管理',
    },
    component: () => import('../views/coordinate/page/account'),
  },
  {
    path: 'userInfo',
    meta: {
      title: '个人中心',
    },
    component: () => import('../views/coordinate/page/userInfo'),
  }


]